import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useScreenContext } from "../Layout";
import { useParams } from "react-router-dom";
import { useExperiment } from "../../lib/optmize";
import { useSessionStorage } from "react-use";

const OpenIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 8.25l-7.5 7.5-7.5-7.5"
    />
  </svg>
);

const CloseIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M4.5 15.75l7.5-7.5 7.5 7.5"
    />
  </svg>
);

const converObjectToParams = (object: any) => {
  return Object.keys(object)
    .map((key) => {
      return `${key}=${encodeURIComponent(object[key])}`;
    })
    .join("&");
};

function SelectPlan() {
  const { t, i18n } = useTranslation();
  const [screenData, setScreenData] = useScreenContext();
  const [showOthersPlans, setShowOthersPlans] = useState<boolean>(false);
  const [selectedPlan, setselectedPlan] = useState<string>("yearly");
  const [currentFaq, setCurrentFaq] = useState<number>(0);
  const { offerType } = useParams();
  const experimentVariant = useExperiment("qhzfxY4KRVaGNbRQ__TGlQ");
  const [flowStrategy, setFlowStrategy] = useSessionStorage(
    "flow-strategy",
    ""
  );

  const isPostLeadFlowStrategy = flowStrategy === "lead-post-plan-selection";

  const checkoutId: any = {
    br: "P5327674P",
    en: "K16542811H",
    es: "Y16613490E",
  }[i18n.language];

  const offersTrial: any = {
    P5327674P: {
      yearly: { offerCode: "gh9natcc" },
      monthly: { offerCode: "jx5nh72y" },
    },
    K16542811H: {
      yearly: { offerCode: "38tbqvq8" },
      monthly: { offerCode: "fys1w0n7" },
    },
    Y16613490E: {
      yearly: { offerCode: "1dzae3rw" },
      monthly: { offerCode: "7lcaoc5b" },
    },
  };

  const offersDirectSale: any = {
    P5327674P: {
      yearly: {
        offerCode: "ay4dadm7",
      },
      monthly: { offerCode: "kppi78af" },
    },
    K16542811H: {
      yearly: { offerCode: "cdvne1nv" },
      monthly: { offerCode: "b3i96d7z" },
    },
    Y16613490E: {
      yearly: { offerCode: "pyk6vwh7" },
      monthly: { offerCode: "prlt2kyv" },
    },
  };

  const isDirectSale = offerType === "direct";
  const offers: any = isDirectSale ? offersDirectSale : offersTrial;
  const currentCheckout = offers[checkoutId];

  const buildCheckoutLink = () => {
    const baseUrl = `https://pay.hotmart.com/${checkoutId}`;
    const urlParams = !isPostLeadFlowStrategy ? screenData.urlParams : {};
    return (
      baseUrl +
      "?" +
      converObjectToParams({
        ...urlParams,
        off: currentCheckout[selectedPlan].offerCode,
      })
    );
  };

  const buildNextPath = () => {
    const checkoutLink = buildCheckoutLink();
    return !isPostLeadFlowStrategy
      ? checkoutLink
      : "form?redirectUrl=" + encodeURIComponent(checkoutLink);
  };

  useEffect(() => {
    setScreenData(() => ({
      ...screenData,
      submitLabel: t("layout.cta_continue"),
      nextPath: buildNextPath(),
      progress: 100,
    }));
  }, [selectedPlan]);

  return (
    <div>
      {experimentVariant === 1 ? (
        <div className="bg-red-100 p-5">
          <div className="mb-3 inline-block rounded-md bg-red-600 p-2 text-white">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="mr-1 inline-block h-5 w-5"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 6v6h4.5m4.5 0a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
            {t("landing.badge")}
          </div>
          <h1 className="my-5 text-4xl font-semibold leading-tight text-red-600">
            {t("landing.headline")}
          </h1>
          <p>{t("landing.subheadline")}</p>

          <div className={"mt-10 border-4 border-blue-700 text-gray-900"}>
            <div className=" bg-gray-100 p-4 py-6">
              <div>
                <div className=" -mt-10 mb-2 w-28  bg-blue-700 py-1 text-center text-xs text-white">
                  {t("landing.save_text")} {t("landing.save_offer_exp")}
                </div>
                <b className="mt-5 block text-lg">12MIN PREMIUM</b>
                <div className="py-2">
                  <span className="mr-2 inline-block font-light text-red-600 line-through">
                    {t("landing.old_price_exp")}
                  </span>
                  <b className="inline-block text-xl">
                    {t(
                      `select_plan.yearly.${
                        isDirectSale ? "direct_sale_" : ""
                      }plan_price_per_month`
                    )}
                  </b>
                </div>
                <b className="block text-sm text-blue-700">
                  {t(
                    `select_plan.yearly.${
                      isDirectSale ? "direct_sale_" : ""
                    }free_trial`
                  )}
                </b>
              </div>
            </div>
            <div className="bg-white p-4 text-left">
              <div className="mt-2 text-left text-sm">
                <div className="mb-3">
                  <p className="align-middle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="inline-block h-4 w-5 text-blue-700"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("landing.feature_1", {
                          interpolation: { escapeValue: false },
                        }),
                      }}
                    ></span>
                  </p>
                </div>

                <div className="mb-3">
                  <p className="align-middle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="inline-block h-4 w-5 text-blue-700 "
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("landing.feature_2", {
                          interpolation: { escapeValue: false },
                        }),
                      }}
                    ></span>
                  </p>
                </div>

                <div className="mb-3">
                  <p className="align-middle">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth={1.5}
                      stroke="currentColor"
                      className="inline-block h-4 w-5 text-blue-700 "
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M4.5 12.75l6 6 9-13.5"
                      />
                    </svg>
                    <span
                      dangerouslySetInnerHTML={{
                        __html: t("landing.feature_3", {
                          interpolation: { escapeValue: false },
                        }),
                      }}
                    ></span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <h1 className="mb-4 mt-5 text-4xl font-bold tracking-tight text-gray-900 dark:text-white md:text-5xl lg:text-6xl">
            {t("select_plan.headline")}
          </h1>
          <div>
            <div
              onClick={() => setselectedPlan("yearly")}
              className={
                "mt-10 cursor-pointer border-4 text-gray-900 " +
                (selectedPlan === "yearly"
                  ? "border-green-400"
                  : "border-gray-400")
              }
            >
              <div className="flex bg-gray-100 p-4 py-6 text-left">
                <div className="pr-4">
                  <div className="mt-1.5 rounded-full border-2 border-gray-900 bg-white p-0.5">
                    <div
                      className={
                        "h-2 w-2 rounded-full  bg-gray-900 " +
                        (selectedPlan === "yearly" ? "bg-gray-900" : "bg-white")
                      }
                    ></div>
                  </div>
                </div>
                <div>
                  <div className="-ml-11 -mt-10 mb-2 w-28  bg-blue-700 py-1 text-center text-xs text-white">
                    {t("select_plan.yearly.tip")}
                  </div>
                  <b className="mt-5 block text-sm">
                    {t("select_plan.yearly.plan_name")}
                  </b>
                  <div className="py-2">
                    <b className="block">
                      {t(
                        `select_plan.yearly.${
                          isDirectSale ? "direct_sale_" : ""
                        }plan_price_per_month`
                      )}
                    </b>
                  </div>
                  <b className="block text-sm text-blue-700">
                    {t(
                      `select_plan.yearly.${
                        isDirectSale ? "direct_sale_" : ""
                      }free_trial`
                    )}
                  </b>
                </div>
              </div>
              <div className="ml-8 p-4 text-left">
                <b className="text-sm">
                  {t(
                    `select_plan.yearly.${
                      isDirectSale ? "direct_sale_" : ""
                    }how_trial_works`
                  )}
                  :
                </b>
                <div className="mt-2 text-left text-sm">
                  <div className="mb-3">
                    <b className="text-blue-700">
                      {t("book_list.trial_box.today.headline")}
                    </b>
                    <p className="font-light">
                      {t(
                        `book_list.trial_box.today.${
                          isDirectSale ? "direct_sale_" : ""
                        }text`
                      )}
                    </p>
                  </div>
                  <div className="mb-3">
                    <b className="text-blue-700">
                      {t("book_list.trial_box.day5.headline")}
                    </b>
                    <p className="font-light">
                      {t(
                        `book_list.trial_box.day5.${
                          isDirectSale ? "direct_sale_" : ""
                        }text`
                      )}
                    </p>
                  </div>
                  <div className="mb-3">
                    <b className="text-blue-700">
                      {t("book_list.trial_box.day7.headline")}
                    </b>
                    <p className="font-light">
                      {t("book_list.trial_box.day7.text")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="py-3 text-sm text-blue-600"
              onClick={() => setShowOthersPlans(!showOthersPlans)}
            >
              <span className="cursor-pointer">
                {t("select_plan.show_others_plans")}
              </span>
            </div>
            {showOthersPlans && (
              <div
                onClick={() => setselectedPlan("monthly")}
                className={
                  "cursor-pointer border-4  text-gray-900 " +
                  (selectedPlan === "monthly"
                    ? "border-green-400"
                    : "border-gray-400")
                }
              >
                <div className="flex bg-gray-100 p-4 py-6 text-left">
                  <div className="pr-4">
                    <div className="mt-0.5 rounded-full border-2 border-gray-900 bg-white p-0.5">
                      <div
                        className={
                          "h-2 w-2 rounded-full  bg-gray-900 " +
                          (selectedPlan === "monthly"
                            ? "bg-gray-900"
                            : "bg-white")
                        }
                      ></div>
                    </div>
                  </div>
                  <div>
                    <b className="block text-sm">
                      {t("select_plan.monthly.plan_name")}
                    </b>
                    <div className="py-2">
                      <b className="block">
                        {t(
                          `select_plan.monthly.${
                            isDirectSale ? "direct_sale_" : ""
                          }plan_price_per_month`
                        )}
                      </b>
                    </div>
                    <b className="block text-sm text-blue-700">
                      {t(
                        `select_plan.monthly.${
                          isDirectSale ? "direct_sale_" : ""
                        }no_trial`
                      )}
                    </b>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div>
        <h2 className="mb-4 mt-5 text-2xl font-bold tracking-tight text-gray-900 dark:text-white md:text-3xl lg:text-4xl">
          {t("select_plan.faq.headline")}
        </h2>

        <div className="text-left">
          <div className="border-b border-gray-500">
            <div
              className="flex cursor-pointer"
              onClick={() => setCurrentFaq(1)}
            >
              <div className="mt-3 pr-3">
                {currentFaq === 1 ? <CloseIcon /> : <OpenIcon />}
              </div>
              <div>
                <h3 className="py-3 font-bold">
                  {t("select_plan.faq.q1.question")}
                </h3>
              </div>
            </div>
            {currentFaq === 1 && (
              <div className="pb-3">
                <p className="text-sm font-light text-gray-700 ">
                  {t("select_plan.faq.q1.answer")}
                </p>
              </div>
            )}
          </div>

          <div className="border-b border-gray-500">
            <div
              className="flex cursor-pointer"
              onClick={() => setCurrentFaq(2)}
            >
              <div className="mt-3 pr-3">
                {currentFaq === 2 ? <CloseIcon /> : <OpenIcon />}
              </div>
              <div>
                <h3 className="py-3 font-bold">
                  {t(
                    `select_plan.faq.${
                      isDirectSale ? "direct_sale_" : ""
                    }q2.question`
                  )}
                </h3>
              </div>
            </div>
            {currentFaq === 2 && (
              <div className="pb-3">
                <p className="text-sm font-light text-gray-700 ">
                  {t(
                    `select_plan.faq.${
                      isDirectSale ? "direct_sale_" : ""
                    }q2.answer`
                  )}
                </p>
              </div>
            )}
          </div>

          <div className="border-b border-gray-500">
            <div
              className="flex cursor-pointer"
              onClick={() => setCurrentFaq(3)}
            >
              <div className="mt-3 pr-3">
                {currentFaq === 3 ? <CloseIcon /> : <OpenIcon />}
              </div>
              <div>
                <h3 className="py-3 font-bold">
                  {t("select_plan.faq.q3.question")}
                </h3>
              </div>
            </div>
            {currentFaq === 3 && (
              <div className="pb-3">
                <p className="text-sm font-light text-gray-700 ">
                  {t("select_plan.faq.q3.answer")}
                </p>
              </div>
            )}
          </div>

          <div className="border-b border-gray-500">
            <div
              className="flex cursor-pointer"
              onClick={() => setCurrentFaq(4)}
            >
              <div className="mt-3 pr-3">
                {currentFaq === 4 ? <CloseIcon /> : <OpenIcon />}
              </div>
              <div>
                <h3 className="py-3 font-bold">
                  {t("select_plan.faq.q4.question")}
                </h3>
              </div>
            </div>
            {currentFaq === 4 && (
              <div className="pb-3">
                <p className="text-sm font-light text-gray-700 ">
                  {t("select_plan.faq.q4.answer")}
                </p>
              </div>
            )}
          </div>

          <div className="border-b border-gray-500">
            <div
              className="flex cursor-pointer"
              onClick={() => setCurrentFaq(5)}
            >
              <div className="mt-3 pr-3">
                {currentFaq === 5 ? <CloseIcon /> : <OpenIcon />}
              </div>
              <div>
                <h3 className="py-3 font-bold">
                  {t(
                    `select_plan.faq.${
                      isDirectSale ? "direct_sale_" : ""
                    }q5.question`
                  )}
                </h3>
              </div>
            </div>
            {currentFaq === 5 && (
              <div className="pb-3">
                <p className="text-sm font-light text-gray-700 ">
                  {t(
                    `select_plan.faq.${
                      isDirectSale ? "direct_sale_" : ""
                    }q5.answer`
                  )}
                </p>
              </div>
            )}
          </div>

          <div className="border-gray-500 pb-20">
            <div
              className="flex cursor-pointer"
              onClick={() => setCurrentFaq(6)}
            >
              <div className="mt-3 pr-3">
                {currentFaq === 6 ? <CloseIcon /> : <OpenIcon />}
              </div>
              <div>
                <h3 className="py-3 font-bold">
                  {t("select_plan.faq.q6.question")}
                </h3>
              </div>
            </div>
            {currentFaq === 6 && (
              <div className="pb-3">
                <p className="text-sm font-light text-gray-700 ">
                  {t("select_plan.faq.q6.answer")}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectPlan;
